import LazyLoad from './src/LazyLoad';
export default LazyLoad;


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-lazy-load/index.js
// module id = 811
// module chunks = 0